import Admin from "./admin/Admin";
import Modalidades from "./admin/Modalidades";
import TrainingType from "./admin/TrainingType";
import Origins from "./admin/Origins";
import ReasonsForAbsence from "./admin/ReasonsForAbsence";
import Trainings from "./admin/Trainings";
// import Matrix from "./admin/Matrix";
// import Status from "./admin/Status";
import EvaluationFactor from "./admin/MetricEvaluationFactor";
// import FormalEducationMetrics from "./admin/FormalEducationMetrics";
// import MetricNineBoxes from "./admin/MetricNineBoxes";
// import MetricJobExperience from "./admin/MetricJobExperience";
import TrainingEvents from "./TrainingEvents";
import Approaches from "./admin/Approaches";
import Campaigns from "./Campaigns";
import EmployeeMonitor from "./EmployeeMonitor";
import TrainingAssistance from "./TrainingAssistance";
// import NineBoxes from "./NineBoxes";
import DetailTrainingMonitor from "./DetailTrainingMonitor";
import FormEvalCapa from "./FormEvalCapa";
import DashboardResponsable from "./powerBi/DashboardResponsable";
import GoalPerYear from "./admin/GoalPerYear";
import EvaluableEmployeeMonitor from "./EvaluableEmployeeMonitor";
import BudgetControl from "./BudgetControl";
import CompaniesBudget from "./admin/CompaniesBudget";
import TrainingNeedsManagement from "./TrainingNeedsManagement";
import EnrollmentRequest from "./EnrollmentRequest";
import DNCForm from "./admin/DNCForm";
import TrainingCalendar from "../../components/capacitacionDesarrollo/TrainingCalendar";

const CapacitacionDesarrolloRouter = [
  {
    type: "private",
    path: "/capacitacion-desarrollo/admin",
    roles: ["administrador", "Responsable_Capacitacion"],
    component: Admin,
    exact: true,
  },
  {
    type: "private",
    path: "/capacitacion-desarrollo/modalidades",
    roles: ["administrador", "Responsable_Capacitacion"],
    component: Modalidades,
    exact: true,
  },
  {
    type: "private",
    path: "/capacitacion-desarrollo/tipo-capacitacion",
    roles: ["administrador", "Responsable_Capacitacion"],
    component: TrainingType,
    exact: true,
  },
  {
    type: "private",
    path: "/capacitacion-desarrollo/origines",
    roles: ["administrador", "Responsable_Capacitacion"],
    component: Origins,
    exact: true,
  },
  {
    type: "private",
    path: "/capacitacion-desarrollo/motivos-inasistencia",
    roles: ["administrador", "Responsable_Capacitacion"],
    component: ReasonsForAbsence,
    exact: true,
  },
  {
    type: "private",
    path: "/capacitacion-desarrollo/capacitaciones",
    roles: ["administrador", "Responsable_Capacitacion"],
    component: Trainings,
    exact: true,
  },
  // {
  //   type: "private",
  //   path: "/capacitacion-desarrollo/matriz",
  //   roles: ["administrador", "Responsable_Capacitacion"],
  //   component: Matrix,
  //   exact: true,
  // },
  // {
  //   type: "private",
  //   path: "/capacitacion-desarrollo/estados",
  //   roles: ["administrador", "Responsable_Capacitacion"],
  //   component: Status,
  //   exact: true,
  // },
  {
    type: "private",
    path: "/capacitacion-desarrollo/metrica-evaluacion-factor",
    roles: ["administrador", "Responsable_Capacitacion"],
    component: EvaluationFactor,
    exact: true,
  },
  // {
  //   type: "private",
  //   path: "/capacitacion-desarrollo/educacion-formal-metricas",
  //   roles: ["administrador", "Responsable_Capacitacion"],
  //   component: FormalEducationMetrics,
  //   exact: true,
  // },
  // {
  //   type: "private",
  //   path: "/capacitacion-desarrollo/metrica-nueve-cajas",
  //   roles: ["administrador", "Responsable_Capacitacion"],
  //   component: MetricNineBoxes,
  //   exact: true,
  // },
  // {
  //   type: "private",
  //   path: "/capacitacion-desarrollo/metrica-experiencia-en-puesto",
  //   roles: ["administrador", "Responsable_Capacitacion"],
  //   component: MetricJobExperience,
  //   exact: true,
  // },
  {
    type: "private",
    path: "/capacitacion-desarrollo/enfoques",
    roles: ["administrador", "Responsable_Capacitacion"],
    component: Approaches,
    exact: true,
  },
  {
    type: "private",
    path: "/capacitacion-desarrollo/empresas-presupuesto",
    roles: ["administrador", "Responsable_Capacitacion"],
    component: CompaniesBudget,
    exact: true,
  },
    {
    type: "private",
    path: "/capacitacion-desarrollo/formulario-dnc",
    roles: ["administrador", "Responsable_Capacitacion"],
    component: DNCForm,
    exact: true,
  },
  {
    type: "private",
    path: "/capacitacion-desarrollo/eventos-capacitacion/:idCampania/:nombreCampania/:codigoCampania",
    roles: ["administrador", "Responsable_Capacitacion"],
    component: TrainingEvents,
    exact: true,
  },
  {
    type: "private",
    path: "/capacitacion-desarrollo/monitor-colaboradores",
    roles: [
      "administrador",
      "jefe",
      "empleado",
      "Responsable_Capacitacion",
      "alta_direccion",
    ],
    component: EmployeeMonitor,
    exact: true,
  },
  {
    type: "private",
    path: "/capacitacion-desarrollo/registro-cursos",
    roles: [
      "empleado",
      "jefe"
    ],
    component: EnrollmentRequest,
    exact: true,
  },
    {
    type: "private",
    path: "/capacitacion-desarrollo/calendario-capacitaciones",
    roles: [
      "empleado",
    ],
    component: TrainingCalendar,
    exact: true,
  },
  {
    type: "private",
    path: "/capacitacion-desarrollo/rutas-capacitacion",
    roles: ["administrador", "Responsable_Capacitacion", "jefe"],
    component: Campaigns,
    exact: true,
  },
  {
    type: "private",
    path: "/capacitacion-desarrollo/asistencia-capacitacion/:id/:idEvento",
    roles: ["administrador", "Responsable_Capacitacion"],
    component: TrainingAssistance,
    exact: true,
  },
  // {
  //   type: "private",
  //   path: "/capacitacion-desarrollo/matriz-nueve-cajas",
  //   roles: [
  //     "administrador",
  //     "jefe",
  //     "Responsable_Capacitacion",
  //     "alta_direccion",
  //   ],
  //   component: NineBoxes,
  //   exact: true,
  // },
  {
    type: "private",
    path: "/capacitacion-desarrollo/monitor-detalle/:id/:nombre/:idCampania",
    roles: [
      "administrador",
      "jefe",
      "Responsable_Capacitacion",
      "empleado",
      "alta_direccion",
    ],
    // path: "/capacitacion-desarrollo/monitor-detalle/:ruta",
    // roles: ["administrador", "jefe", "Responsable_Capacitacion"],
    component: DetailTrainingMonitor,
    exact: true,
  },
  {
    type: "private",
    path: "/capacitacion-desarrollo/formato-evaluacion-capacitacion/:id/:id_empleado",
    roles: [
      "administrador",
      "jefe",
      "Responsable_Capacitacion",
      "alta_direccion",
    ],
    component: FormEvalCapa,
    exact: true,
  },
  {
    type: "private",
    path: "/capacitacion-desarrollo/control-presupuesto",
    roles: ["administrador", "Responsable_Capacitacion"],
    component: BudgetControl,
    exact: true,
  },
  {
    type: "private",
    path: "/capacitacion-desarrollo/gestion-necesidades",
    roles: ["administrador", "Responsable_Capacitacion", "jefe"],
    component: TrainingNeedsManagement,
    exact: true,
  },
  {
    type: "private",
    // path: "/capacitacion-desarrollo/indicadores-capacitacion",
    path: "/capacitacion-desarrollo/tablero-capacitaciones",
    roles: ["administrador", "Responsable_Capacitacion"],
    component: DashboardResponsable,
    exact: true,
  },
  {
    type: "private",
    path: "/capacitacion-desarrollo/meta-por-anio",
    roles: ["administrador", "Responsable_Capacitacion"],
    component: GoalPerYear,
    exact: true,
  },
  {
    type: "private",
    path: "/capacitacion-desarrollo/monitor-colaboradores-evaluables",
    roles: ["administrador", "Responsable_Capacitacion"],
    component: EvaluableEmployeeMonitor,
    exact: true,
  }
];

export default CapacitacionDesarrolloRouter;
